<template>
    <v-dialog v-model="dialog" max-width="1500px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
            text
            v-bind="attrs"
            v-on="on"
            ><v-icon>mdi-plus</v-icon></v-btn>
        </template>

        <v-card outlined class="pa-3">
                <v-card-title ><strong>เพิ่มข้อมูลบริการเสริม</strong></v-card-title>
                <v-divider class="ma-2"></v-divider>
                <div class="pl-5 pr-5">
                    <v-form ref="formData" lazy-validation>
                    <v-row>
                        <v-col>
                            <v-select
                                v-model="selectedExtPackage"
                                label="ชื่อบริการเสริม"
                                return-object
                                :rules="[rules.required]"
                                :items="items"
                                item-text="ext_package_name"
                                item-value="ext_package_id"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <PeriodComponent 
                        ref="periodcomponent"
                        @setStartDate="setStartPackageDate" 
                        @setEndDate="setEndPackageDate"
                    ></PeriodComponent>
                    </v-form> 
                </div>
                <v-divider></v-divider>
                <v-card-actions class="text-right">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="saveDialog">บันทึก</v-btn>
                    <v-btn color="primary" @click="closeDialog"> ยกเลิก</v-btn>
                </v-card-actions>
            </v-card>
    </v-dialog>
</template>

<style scoped>
    .right-text {
        text-align: right;
    }
</style>
<script>

import PeriodComponent from '@/components/Common/PeriodComponent'

export default {
    name: 'DlgCustomer',
    components: {
        PeriodComponent
    },
    props: ["items"],
    data: () => ({
        rules: {
            required: value => !!value.ext_package_id || 'กรุณากรอกข้อมูล.'
        },
        isEdit: false,
        dialog: false,
        selectedExtPackage: {},
        editedItem: {
            startPackageDate: '',
            endPackageDate: ''
        }
    }),
    methods: {
        setStartPackageDate(val) {
            this.editedItem.startPackageDate = val;
        },
        setEndPackageDate(val) {
            this.editedItem.endPackageDate = val;
        },
        saveDialog() {
            if (!this.$refs.formData.validate()) {
                return;
            }
            this.editedItem.ext_package_id = this.selectedExtPackage.ext_package_id;
            this.editedItem.ext_package_name = this.selectedExtPackage.ext_package_name;
            this.closeDialog(this.editedItem);
        },
        closeDialog(item) {
            this.editedItem = {};
            this.selectedExtPackage = {};
            this.dialog = false;
            this.isEdit = false;
            this.$emit("onCloseDialog", item);
            this.$refs.periodcomponent.clear()
        },
        show(item) {
            this.dialog = true;
            this.editedItem = item;
            this.isEdit = true;
        }
    }
}
</script>